import { render, staticRenderFns } from "./ReportInvoiceAnalyticsByGroup.vue?vue&type=template&id=135afe51"
import script from "./ReportInvoiceAnalyticsByGroup.vue?vue&type=script&lang=js"
export * from "./ReportInvoiceAnalyticsByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports